export default "__VITE_PUBLIC_ASSET__9543d136__"